// src/store/subItemSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = 'http://localhost:3000/api/subitems';

// Thunks
export const fetchSubItems = createAsyncThunk('subItem/fetchAll', async () => {
  const res = await axios.get(API_BASE);
  return res.data;
});

export const createSubItem = createAsyncThunk('subItem/create', async (formData) => {
  const res = await axios.post(API_BASE, formData);
  return res.data;
});

export const updateSubItem = createAsyncThunk('subItem/update', async ({ id, formData }) => {
  const res = await axios.patch(`${API_BASE}/${id}`, formData);
  return res.data;
});

// Slice
const subItemSlice = createSlice({
  name: 'subItem',
  initialState: {
    subItems: [],
    isLoading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetSubItemState: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchSubItems.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSubItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subItems = action.payload;
      })
      .addCase(fetchSubItems.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createSubItem.fulfilled, (state, action) => {
        state.subItems.unshift(action.payload);
        state.success = true;
      })
      .addCase(createSubItem.rejected, (state, action) => {
        state.error = action.error.message;
      })

      // Update
      .addCase(updateSubItem.fulfilled, (state, action) => {
        const index = state.subItems.findIndex((s) => s.id === action.payload.id);
        if (index !== -1) {
          state.subItems[index] = action.payload;
        }
        state.success = true;
      })
      .addCase(updateSubItem.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export const { resetSubItemState } = subItemSlice.actions;
export default subItemSlice.reducer;
